<template>
    <div class="pneu-offer migrol-form">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
    };
</script>